import { render, staticRenderFns } from "./XbrlAnalysisFilters.vue?vue&type=template&id=0baf308c&"
import script from "./XbrlAnalysisFilters.vue?vue&type=script&lang=js&"
export * from "./XbrlAnalysisFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports